<template>
    <v-dialog v-model="internal_show" max-width="800px" persistent>
        <v-card>
            <v-card-title class="headline">
                Gerenciar Categorias de Despesas
                <v-spacer></v-spacer>
                <v-btn icon @click="internal_show = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" class="d-flex justify-end">
                         <v-btn color="primary-blue" dark @click="openCreate">Nova Categoria</v-btn>
                    </v-col>
                </v-row>
                <v-data-table
                    :headers="headers"
                    :items="categories"
                    :loading="loading"
                    class="elevation-1 mt-4"
                >
                    <template v-slot:[`item.actions`]="{ item }">
                         <v-icon small class="mr-2" @click="editItem(item)">
                            mdi-pencil
                        </v-icon>
                        <v-icon small @click="deleteItem(item)" v-if="item.id !== 1">
                            mdi-delete
                        </v-icon>
                        <v-icon small disabled v-else>
                             mdi-delete-off
                        </v-icon>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <!-- Dialog Create/Edit -->
        <v-dialog v-model="dialog_form" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field v-model="editedItem.name" label="Nome da Categoria"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea v-model="editedItem.description" label="Descrição"></v-textarea>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeForm">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog Confirm Delete -->
        <v-dialog v-model="dialog_delete" max-width="500px">
            <v-card>
                <v-card-title class="headline">Tem certeza que deseja deletar?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    props: {
        value: Boolean
    },
    data: () => ({
        headers: [
            { text: 'Nome', value: 'name' },
            { text: 'Descrição', value: 'description' },
            { text: 'Ações', value: 'actions', sortable: false },
        ],
        dialog_form: false,
        dialog_delete: false,
        editedIndex: -1,
        editedItem: {
            name: '',
            description: '',
        },
        defaultItem: {
            name: '',
            description: '',
        },
        loading: false,
        itemToDelete: null,
    }),
    computed: {
        ...mapState('taxes', ['tax_categories_list']),
        internal_show: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        formTitle() {
            return this.editedIndex === -1 ? 'Nova Categoria' : 'Editar Categoria';
        },
        categories() {
            return this.tax_categories_list || [];
        }
    },
    watch: {
        internal_show(val) {
            if (val) {
                this.fetchCategories();
            }
        }
    },
    methods: {
        ...mapActions('taxes', ['ActionDoGetTaxCategories', 'ActionDoCreateTaxCategory', 'ActionDoUpdateTaxCategory', 'ActionDoDeleteTaxCategory']),
        
        fetchCategories() {
            this.loading = true;
            this.ActionDoGetTaxCategories().finally(() => {
                this.loading = false;
            });
        },

        openCreate() {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
            this.dialog_form = true;
        },

        editItem(item) {
            this.editedIndex = this.categories.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog_form = true;
        },

        deleteItem(item) {
            this.itemToDelete = item;
            this.dialog_delete = true;
        },

        deleteItemConfirm() {
            this.ActionDoDeleteTaxCategory(this.itemToDelete.id).then(() => {
                this.fetchCategories();
                this.closeDelete();
            });
        },

        closeDelete() {
            this.dialog_delete = false;
            this.$nextTick(() => {
                this.itemToDelete = null;
            });
        },

        closeForm() {
            this.dialog_form = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        save() {
            if (this.editedIndex > -1) {
                this.ActionDoUpdateTaxCategory(this.editedItem).then(() => {
                    this.fetchCategories();
                    this.closeForm();
                });
            } else {
                this.ActionDoCreateTaxCategory(this.editedItem).then(() => {
                    this.fetchCategories();
                    this.closeForm();
                });
            }
        },
    },
};
</script>
